export default __webpack_public_path__ + "static/media/clock.1aef57ed.svg";